import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { AbstractService } from '../../services/abstract.service';

//  Libraries
import { DialogRef, ModalComponent } from 'angular2-modal';
import { BSModalContext } from 'angular2-modal/plugins/bootstrap';

export class AbstractModalWindow extends BSModalContext {
    public id: number;
}

@Component({
    selector: 'view-abstract-component',
    templateUrl: './viewAbstract.component.html',
    providers: []
})

export class ViewAbstractComponent implements ModalComponent<AbstractModalWindow>, OnInit {

    modalContext: AbstractModalWindow;
    abstract: any = {};

    constructor(
        private router: Router,
        private authService: AuthenticationService,
        private abstractService: AbstractService,
        public dialog: DialogRef<AbstractModalWindow>) {

        this.modalContext = dialog.context;
        this.modalContext.dialogClass = 'modal-side-bar side-bar-narrow';
    }

    ngOnInit() {

        this.abstractService.getAbstract(this.modalContext.id)
            .subscribe(abstract => {
                this.abstract = abstract;
            }, err => {
                console.log(err);
            });
    }

    close() {
        this.dialog.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/abstract/viewAbstract.component.ts